<div class="banner" [ngClass]="isCorporate ? 'banner-corporate' : 'banner-default'">
  <div class="container">
    <h1 [ngClass]="isCorporate ? 'font-corporate' : 'font-default'">{{ title }}</h1>
  </div>
</div>
